<template>
  <div>
    <b-overlay :show="loading" opacity="0.99">
      <v-data-table
        dense
        :headers="headers"
        :items="residents"
        :footer-props="{
          'items-per-page-options': [100, 200, 300],
          'items-per-page-text': 'Mostrar',
        }"
      >
        <template v-slot:[`item.status_type_name`]="{ item }">{{
          item.active ? item.status_type_name : "Inativo"
        }}</template>
        <template v-slot:[`item.date_of_birth`]="{ item }">
          <td>
            <span
              class="text-primary"
              v-b-tooltip.html
              :title="`Data de nascimento <br /> ${formatDate(
                item.date_of_birth,
                false
              )}`"
              >{{ getAge(item.date_of_birth) }} anos</span
            >
          </td>
        </template>
      </v-data-table>
    </b-overlay>
  </div>
</template>

<script>
import api from "../../services/api";

import { formatDate } from "../../functions/format";

import { getAge } from "../../functions/getAgeByDate";

export default {
  name: "RestHomeResident",

  data() {
    return {
      headers: [
        { text: "Status", value: "status_type_name" },
        { text: "Nome", value: "name" },
        { text: "Idade", value: "date_of_birth" },
        { text: "Sexo", value: "gender_name" },
      ],

      residents: [],

      rest_home_id: "",

      loading: false,

      errors: [],
    };
  },
  created() {
    this.retrieve();
  },
  methods: {
    getAge,
    formatDate,

    retrieve() {
      const { id } = this.$attrs;

      this.rest_home_id = id;

      this.getResidents();
    },

    async getResidents(page = 1) {
      try {
        this.loading = true;

        const { rest_home_id } = this;

        let params = {
          rest_home_id,
          page,
        };

        const response = await api.get("/admin/rest-home/resident/paginate", {
          params,
        });

        const { residents } = response.data;

        this.residents = residents;

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    async getStatusResidents() {
      try {
        const { rest_home_id } = this;

        let params = {
          rest_home_id,
          type: "RESIDENTE",
        };

        const response = await api.get("/admin/rest-home/type/status/all", {
          params,
        });

        const { status } = response.data;

        this.statusTypes = status;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>